import { useEffect, useState } from "react";
import { api } from "../services/apiService";

export function useCmsBatch(keys) {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);
  const dependencyKey = keys.join("|");

  useEffect(() => {
    let active = true;
    api.post("/cms/content/batch", { keys })
      .then((response) => { if (active) setContent(response.data.content || {}); })
      .catch(() => { if (active) setContent({}); })
      .finally(() => { if (active) setLoaded(true); });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependencyKey]);

  return { content, loaded };
}
